import React from 'react'
import styled from 'styled-components'

import { Link, Text, Flex } from './styled'

const LinkContainer = styled(Link)`
  /* background: rgba(100, 100, 100, 0.6); */
  background: black;
  color: white;

  a {
    font-size: 0.8rem;
    margin-left: 16px;
    letter-spacing: -0.5px;
    border-bottom: 1px solid;
    position: relative;
    top: -2px;
  }
`

const SiteBanner = ({ link, children }) => {
  return (
    <LinkContainer to={link} width="100%">
      <Flex width="100%" py={4} justifyContent="center" alignItems="center">
        <Text fontWeight={500}>{children}</Text>
      </Flex>
    </LinkContainer>
  )
}

export default SiteBanner
